import { Controller } from '@hotwired/stimulus';
import toastr from 'toastr';

export default class extends Controller {
  static values = { message: String, level: String };

  connect() {
    toastr[this.levelValue](this.messageValue);
    this.element.remove();
  }
}
